if (!customElements.get('product-form')) {
// Function to update the cart count
async function updateCartCount() {
  try {
      const response = await fetch('/cart.js');
      if (!response.ok) {
          throw new Error('Network response was not ok');
      }
      const cart = await response.json();

      // Update cart count in the UI
      const counterElementParent = document.querySelector(".cart-count-bubble");
      const counterElement = document.querySelector(".cart-count-bubble-item");
      if (counterElementParent.classList.contains("count_hidden")) {
        counterElementParent.classList.remove("count_hidden");
      }
      if (cart.item_count == 0) {
        if (!counterElementParent.classList.contains("count_hidden")) {
          counterElementParent.classList.add("count_hidden");
        }
      }
      if (cart.item_count > 99) {
        counterElement.textContent = "99+";
      } else {
        counterElement.textContent = cart.item_count;
      }
  } catch (error) {
      console.error('Error updating cart count:', error);
      // Optionally, handle the error here
  }
}
customElements.define(
  'product-form',
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.variantIdInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.cartDrawerDiv = document.querySelector('#CartDrawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.submitButton.querySelector('span');

      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      const toRender = [];

      if (this.cart) {
        toRender.push(...this.cart.getSectionsToRender().map((section) => section.id));
      }
      if (this.cartDrawer) {
        toRender.push(...this.cartDrawer.getSectionsToRender().map((section) => section.id));
      }
      if (toRender.length > 0) {
        formData.append(
          'sections',
          [...new Set(toRender)]
        );
        formData.append('sections_url', window.location.pathname);
      }

      if (this.cart) {
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButtonText.classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener(
              'modalClosed',
              () => {
                setTimeout(() => {
                  if (this.cart) {
                    this.cart.renderContents(response);
                    this.cart.open();
                  }
                  if (this.cartDrawer) {
                    this.cartDrawer.renderContents(response);
                  }
                });
              },
              { once: true }
            );
            quickAddModal.hide(true);
          } else {
            if (this.cart) {
              this.cart.renderContents(response);
              this.cart.open();
            }
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(response);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (this.cartDrawer && this.cartDrawer.classList.contains('is-empty')) this.cartDrawer.classList.remove('is-empty');
          if (this.cartDrawerDiv && this.cartDrawerDiv.classList.contains('is-empty')) this.cartDrawerDiv.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper =
        this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    toggleSubmitButton(disable = true, text) {
      if (disable) {
        this.submitButton.setAttribute('disabled', 'disabled');
        if (text) this.submitButtonText.textContent = text;
      } else {
        this.submitButton.removeAttribute('disabled');
        this.submitButtonText.textContent = window.variantStrings.addToCart;
      }
    }

    get variantIdInput() {
      return this.form.querySelector('[name=id]');
    }
  }
);
}
// Set scroll position after click on product in CLP
document.querySelectorAll("a.prod_link").forEach(link => {
  link.addEventListener("click", () => {
    sessionStorage.setItem("clpScrollPosition", window.scrollY);
  });
});
//Restore scroll position after load
window.addEventListener("pageshow", (e) => {
  if (e.persisted) { // Check if page was restored from cache
    const clpScrollPosition = sessionStorage.getItem("clpScrollPosition");
    if (clpScrollPosition) {
      window.scrollTo(0, parseInt(clpScrollPosition));
      sessionStorage.removeItem('clpScrollPosition'); // Clear after use
    }
  }
});